import type { IUserGrantAccessCmd } from "@/data/commands/user/UserGrantAccessCmd";
import { Factory } from "@/data/dao/Factory";
import { UserDao } from "@/data/dao/service/UserDao";
import type { IUserAccessGrant } from "@/data/model/User";

import { BaseModal } from "@/shared/elements/BaseModal";
import { logError } from "@/shared/logging/errors";
import { style } from "@/shared/ui/Style";

import { i18n } from "@/portal/Trans";
import { EntityInput } from "@/portal/formControls/EntityInput";
import { Select } from "@/portal/formControls/Select";

export class LocationAccessWindow extends BaseModal {
    private $form: JQuery;

    private claimTypeSelect: Select<{ name: string; type: string }>;
    private userSelect: EntityInput;

    private $valueRow: JQuery;

    private $submitBtn: JQuery;

    private locationId: string;
    private takenUserIds: Array<string>;

    public onSaved?: { (translation: IUserAccessGrant) };
    public onRemoved?: { () };

    constructor(locationId: string, takenUserIds: Array<string>) {
        super(i18n("modal.locationAccess.title"), "modal-lg", true);

        this.locationId = locationId;
        this.takenUserIds = takenUserIds;
        this.$element.addClass("acl");

        this.$form = $('<form class="kt-form kt-form--label-right" />').appendTo(this.$body);
        const createSection = $('<div class="kt-section kt-section--first"><div class="kt-section__body" /></div>')
            .appendTo(this.$form)
            .find("> .kt-section__body");
        createSection.append(
            '<div class="row"><label class="col-xl-4"></label><div class="col-lg-9 col-xl-6"><h3 class="kt-section__title kt-section__title-sm">' +
                i18n("modal.locationAccess.grants") +
                "</h3></div></div>"
        );

        const claimTypeContainer = $(
            '<div class="form-group row"><label class="col-xl-4 col-form-label">' +
                i18n("general.fields.type") +
                ' <span class="mandatory">*</span></label><div class="col-xl-6" /></div>'
        )
            .appendTo(createSection)
            .find("> .col-xl-6");
        const claimTypeSelect = $(
            '<select class="form-control"><option value="http://tastier.ch/claims/locationgrant">' +
                i18n("modal.locationAccess.editLocation") +
                "</option></select>"
        ).appendTo(claimTypeContainer);

        this.$valueRow = $(
            '<div class="form-group row"><label class="col-xl-4 col-form-label">' +
                i18n("general.entities.user") +
                ' <span class="mandatory">*</span></label><div class="col-xl-6" /></div>'
        ).appendTo(createSection);
        this.userSelect = new EntityInput({
            dataSource: Factory.getInstance<UserDao>(UserDao),
            takenIds: this.takenUserIds,
        }).renderTo(this.$valueRow.find("> .col-xl-6"));

        this.claimTypeSelect = Select.createFromSelect(
            claimTypeSelect,
            undefined,
            (f) => f.name,
            undefined,
            undefined,
            "type",
            false
        );
        this.claimTypeSelect.setValue("http://tastier.ch/claims/locationgrant");

        $('<button type="button" class="btn btn-secondary">' + i18n("general.cancel") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.close();
            });

        this.$submitBtn = $('<button type="button" class="btn btn-success">' + i18n("general.save") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();
                this.$form.submit();
            });

        this.$form.submit((e) => {
            e.preventDefault();
            e.stopPropagation();

            this.onSubmit();
            return false;
        });
    }

    private onSubmit() {
        const cmd: IUserGrantAccessCmd = {
            type: this.claimTypeSelect.getValue()!,
            value: this.locationId,
        };

        let hasError = false;
        this.$form.find(".is-invalid").removeClass("is-invalid");

        if (cmd.type === undefined) {
            hasError = true;
            this.claimTypeSelect.setError(true);
        } else this.claimTypeSelect.setError(false);

        const selectedUser = this.userSelect.getValue();
        if (selectedUser === undefined) {
            hasError = true;
            this.userSelect.setError(true);
        } else this.userSelect.setError(false);

        if (hasError) return;

        this.$submitBtn.addClass(style.buttonLoaderClass).prop("disabled", true).find("> .la").remove();
        Factory.getInstance<UserDao>(UserDao)
            .grantAccess(selectedUser!, cmd)
            .then((m) => {
                this.$submitBtn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                if (this.$submitBtn.find("> .la").length === 0) this.$submitBtn.prepend('<i class="la la-save" />');

                this.close();
                if (this.onSaved !== undefined) this.onSaved(m);
            })
            .catch((ex) => {
                logError(ex);
                this.$submitBtn.removeClass(style.buttonLoaderClass).prop("disabled", false);
                if (this.$submitBtn.find("> .la").length === 0) this.$submitBtn.prepend('<i class="la la-save" />');

                alert(i18n("modal.locationAccess.failedGranting", { reason: ex.message }));
            });
    }
}
